import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Envelope } from "@phosphor-icons/react";
import { POLICIES, COMPANY, renderPolicySection } from "./policyContent";

const NAV = [
    { slug: "refund",     label: "Refund policy" },
    { slug: "grievances", label: "Grievances" },
    { slug: "fraud",      label: "Fraud policy" },
    { slug: "payment",    label: "Payment policy" },
    { slug: "privacy",    label: "Privacy" },
    { slug: "terms",      label: "Terms" },
    { slug: "shipping",   label: "Delivery & fulfilment" },
];

export default function PolicyPage() {
    const { slug } = useParams();
    const doc = POLICIES[slug];

    if (!doc) {
        return (
            <div className="max-w-3xl mx-auto p-10">
                <p className="font-heading text-2xl font-black">Policy not found</p>
                
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#FAFAFA]" data-testid={`policy-page-${slug}`}>
            {/* Sticky header */}
            <div className="border-b border-[#E5E5E5] bg-white sticky top-0 z-10">
                <div className="max-w-5xl mx-auto px-4 sm:px-6 py-3 flex items-center gap-3">
                    <Link to="/" className="inline-flex items-center gap-1 text-[10px] font-black uppercase tracking-wider text-[#525252] hover:text-ink">
                        <ArrowLeft size={12} weight="bold" /> Home
                    </Link>
                    <span className="text-[#E5E5E5]">·</span>
                    <p className="text-[10px] font-black uppercase tracking-wider text-[#525252]">Legal &amp; policies</p>
                </div>
            </div>

            <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 sm:py-12 grid gap-8 md:grid-cols-[220px_1fr]">
                {/* Sub-nav */}
                <aside className="md:sticky md:top-16 self-start">
                    <p className="text-[10px] font-black uppercase tracking-[0.2em] text-[#A3A3A3] mb-2">All policies</p>
                    <nav className="flex flex-col gap-0.5">
                        {NAV.map((n) => (
                            <Link
                                key={n.slug}
                                to={`/policies/${n.slug}`}
                                data-testid={`policy-nav-${n.slug}`}
                                className={`text-sm px-3 py-2 transition-colors ${
                                    slug === n.slug
                                        ? "bg-ink text-white font-black"
                                        : "text-[#525252] hover:text-ink hover:bg-white"
                                }`}
                            >
                                {n.label}
                            </Link>
                        ))}
                    </nav>
                </aside>

                {/* Content */}
                <article className="bg-white border border-[#E5E5E5] p-6 sm:p-10">
                    <p className="text-[10px] font-black uppercase tracking-[0.25em] text-cobalt mb-2">
                        {COMPANY.trading_name} · Legal
                    </p>
                    <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tight text-ink mb-3">
                        {doc.title}
                    </h1>
                    <p className="text-sm text-[#525252] mb-8 leading-relaxed">{doc.intro}</p>

                    <div className="space-y-6">
                        {doc.sections.map((s, i) => (
                            <section key={i}>
                                <h2 className="font-heading text-lg font-black text-ink mb-2">{s.h}</h2>
                                <p className="text-sm text-[#404040] leading-relaxed">
                                    {renderPolicySection(s.p)}
                                </p>
                            </section>
                        ))}
                    </div>

                    <div className="mt-10 pt-6 border-t border-[#E5E5E5] flex flex-wrap items-center gap-3 text-xs text-[#525252]">
                        <span className="inline-flex items-center gap-1">
                            <Envelope size={12} weight="fill" /> {COMPANY.support_email}
                        </span>
                        <span className="text-[#E5E5E5]">·</span>
                        <span>Last updated {COMPANY.last_updated}</span>
                    </div>
                </article>
            </div>

            {/* Footer */}
            <footer className="border-t border-[#E5E5E5] bg-white mt-12">
                <div className="max-w-5xl mx-auto px-4 sm:px-6 py-6 text-[11px] text-[#525252] flex flex-wrap gap-x-6 gap-y-2">
                    <span>© {new Date().getFullYear()} {COMPANY.legal_name}</span>
                    {COMPANY.address_lines.map((a, i) => (
                        <span key={i}>{a}</span>
                    ))}
                </div>
            </footer>
        </div>
    );
}
